import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { withI18next } from 'lib/i18n/withI18next'
import compose from 'recompose/compose'
import { connect } from 'react-redux'
import ResponsiveImage from 'components/images/responsive-image'
import Swiper from 'react-id-swiper'
import clsx from 'clsx'
import Typo from 'constants/typography'
import styles from './review-carousel-images.scss'

const swiperState = { changing: false }

const ReviewCarouselImages = ({ images, isPhone, selectedImageIndex }) => {
  // states
  const swiperRef = useRef(null)
  const [currentImageIndex, setCurrentImageIndex] = useState(selectedImageIndex)

  // events
  const onSlideChange = () => {
    const { activeIndex } = swiperRef?.current?.swiper || {}
    setCurrentImageIndex(activeIndex)
  }

  const swiperOptions = {
    shouldSwiperUpdate: true,
    slidesPerView: 1,
    on: {
      slideChange: onSlideChange,
      transitionStart: () => {
        swiperState.changing = true
      },
      transitionEnd: () => {
        swiperState.changing = false
      },
    },
  }

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      {isPhone ? (
        <Swiper
          ref={swiperRef}
          initialSlide={selectedImageIndex}
          {...swiperOptions}
        >
          {images.map((image) => (
            <div key={image?.id_product_review_image}>
              <ResponsiveImage
                className="review-swiper-images-container__img"
                src={image?.image_url}
                alt="product-image"
                imgRatio={1.33}
                isLocalImage
              />
              <div
                className={clsx(
                  Typo.caption,
                  'review-swiper-images-container__caption',
                )}
              >
                {`${currentImageIndex + 1}/${images.length}`}
              </div>
            </div>
          ))}
        </Swiper>
      ) : (
        <div className="review-carousel-images-container">
          <div className="review-carousel-images-container__list">
            {images.map((image, index) => (
              <div key={image?.id_product_review_image}>
                <ResponsiveImage
                  className={clsx(
                    'review-carousel-images-container__list__thumbnail',
                    {
                      'review-carousel-images-container__list__selected':
                        currentImageIndex === index,
                    },
                  )}
                  src={image?.image_url}
                  alt="product-image"
                  imgRatio={1.33}
                  isLocalImage
                  onClick={() => setCurrentImageIndex(index)}
                />
              </div>
            ))}
          </div>
          <ResponsiveImage
            className={clsx('review-carousel-images-container__hero')}
            src={images[currentImageIndex]?.image_url}
            alt="product-image"
            imgRatio={1.33}
            isLocalImage
          />
        </div>
      )}
    </React.Fragment>
  )
}

ReviewCarouselImages.defaultProps = {
  // component props
  images: [],
  selectedImageIndex: 0,
}

ReviewCarouselImages.propTypes = {
  // component props
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id_product_review_image: PropTypes.number,
      image_url: PropTypes.string,
    }),
  ),
  selectedImageIndex: PropTypes.number,

  // redux props
  isPhone: PropTypes.bool.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(ReviewCarouselImages)
